import React from 'react';

export const ModalHeaderContent = ({ children, className }) => {
  return <div className={className}>{children}</div>;
};
